"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const luxon_1 = require("luxon");
const react_redux_1 = require("react-redux");
const immutable_1 = require("immutable");
const Box_1 = __importDefault(require("@mui/material/Box"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const styles_1 = require("@mui/material/styles");
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const Remove_1 = __importDefault(require("@mui/icons-material/Remove"));
const ItemizedTransactions_styles_1 = __importDefault(require("containers/NewReports/components/ItemizedTransactions/ItemizedTransactions.styles"));
const accounts_1 = require("companion-app-components/flux/accounts");
const categories_1 = require("companion-app-components/flux/categories");
const tags_1 = require("companion-app-components/flux/tags");
const auth_1 = require("companion-app-components/flux/auth");
const scheduled_transactions_1 = require("companion-app-components/flux/scheduled-transactions");
const transactions_1 = require("companion-app-components/flux/transactions");
const retrievers_1 = require("data/accounts/retrievers");
const types_1 = require("data/transactions/types");
const transactionSelectors = __importStar(require("data/transactions/selectors"));
const reportsSelectors = __importStar(require("data/reports/selectors"));
const utils_1 = require("data/reports/utils");
const state_1 = require("containers/NewReports/state");
const ChartSettings_1 = __importDefault(require("containers/NewReports/components/ChartSettings"));
const useQData_1 = __importDefault(require("components/QData/useQData"));
const useQDialogs_1 = __importDefault(require("components/QDialogs/useQDialogs"));
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const BulkEditPanel_1 = __importDefault(require("components/BulkEditPanel"));
const QButton_1 = __importDefault(require("components/QButton"));
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const happy_star_svg_1 = __importDefault(require("assets/happy-star.svg"));
const utils_2 = require("components/TransactionRegister/TransactionRow2/utils");
const utils_3 = require("./utils");
const ItemizedTable_1 = __importDefault(require("./ItemizedTable"));
const types_2 = require("./types");
const ItemizedTransactions = () => {
    var _a, _b, _c, _d;
    const theme = (0, styles_1.useTheme)();
    const { palette } = theme;
    const { classes, cx } = (0, ItemizedTransactions_styles_1.default)();
    const { qDataSaveTransactions, qDataDeleteTransactions } = (0, useQData_1.default)();
    const { dialogAlert } = (0, useQDialogs_1.default)();
    const { datasetPreferences, setDatasetPreference } = (0, useQPreferences_1.default)();
    const { state, dispatch } = react_1.default.useContext(state_1.ReportsStateContext);
    const { dateRange, filterObject, timeStep } = state;
    const [breakdownBy, setBreakdownBy] = react_1.default.useState('category');
    const [view, setView] = react_1.default.useState('top');
    const [sortBy, setSortBy] = react_1.default.useState('date');
    const [sortDirection, setSortDirection] = react_1.default.useState('desc');
    const [hasUserSorted, setHasUserSorted] = react_1.default.useState(false);
    const [expandedKeys, setExpandedKeys] = react_1.default.useState({});
    const [selectedTxns, setSelectedTxns] = react_1.default.useState((0, immutable_1.Set)());
    const [showBulkEdit, setShowBulkEdit] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        setSelectedTxns((prev) => {
            if (prev.size === 0) {
                return prev;
            }
            const interval = dateRange === null || dateRange === void 0 ? void 0 : dateRange.value;
            const filtered = prev.filter((txn) => {
                if (!interval) {
                    return false;
                }
                const postedOn = (0, utils_3.getTxnField)(txn, 'postedOn');
                if (!postedOn) {
                    return false;
                }
                const selecteTxnDate = luxon_1.DateTime.fromISO(postedOn);
                return selecteTxnDate.isValid && interval.contains(selecteTxnDate);
            });
            if (filtered.size === 0) {
                setShowBulkEdit(false);
            }
            return filtered;
        });
    }, [dateRange, filterObject]);
    const toggleExpanded = react_1.default.useCallback((key, defaultExpanded = true) => {
        setExpandedKeys((prev) => (0, utils_3.getNextExpandedKeys)(prev, key, defaultExpanded));
    }, []);
    const hasFilters = filterObject !== null;
    const handleClearFilters = react_1.default.useCallback((e) => {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setDatasetPreference({ reportsViewStates: { filterObject: null } });
        dispatch({ type: 'update', payload: { filterObject: null } });
    }, [dispatch, setDatasetPreference]);
    const isPayeeBreakdown = breakdownBy === 'payee';
    const isTransactionsView = isPayeeBreakdown || view === 'transactions';
    const collapseAllByDefault = isPayeeBreakdown;
    const tagsById = (0, react_redux_1.useSelector)((store) => tags_1.tagsSelectors.getTags(store));
    const accountsById = (0, react_redux_1.useSelector)((store) => accounts_1.accountsSelectors.getAccountsById(store));
    const categoriesById = (0, react_redux_1.useSelector)((store) => categories_1.categoriesSelectors.getCategoriesById(store));
    const dataset = (0, react_redux_1.useSelector)(auth_1.authSelectors.getCurrentDataset);
    const txnsByAccountId = (0, react_redux_1.useSelector)((store) => transactionSelectors.getTransactionsByAccountId(store, undefined));
    const scheduledTransactionsById = (0, react_redux_1.useSelector)((store) => scheduled_transactions_1.scheduledTransactionsSelectors.getScheduledTransactions(store));
    const getAccountName = react_1.default.useCallback((id) => {
        var _a, _b, _c, _d, _e, _f, _g;
        const accountMap = accountsById;
        const normalizedId = id == null ? '' : String(id);
        const numericId = typeof id === 'number' || (typeof id === 'string' && id.trim() !== '' && Number.isFinite(Number(id)))
            ? String(Number(id))
            : '';
        return (_g = (_f = (_c = (_b = (_a = accountMap === null || accountMap === void 0 ? void 0 : accountMap.get) === null || _a === void 0 ? void 0 : _a.call(accountMap, normalizedId)) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : (_e = (_d = accountMap === null || accountMap === void 0 ? void 0 : accountMap.get) === null || _d === void 0 ? void 0 : _d.call(accountMap, numericId)) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : (0, retrievers_1.getAccountString)(id)) !== null && _g !== void 0 ? _g : '';
    }, [accountsById]);
    const getCategoryName = react_1.default.useCallback((id) => {
        if (!id) {
            return '';
        }
        const name = categories_1.categoriesSelectors.getCategoryString(categoriesById, id);
        return name === 'NOTFOUND' ? '' : (name || '');
    }, [categoriesById]);
    const getTxnAmountForRow = react_1.default.useCallback((txn, row, splitItemId) => {
        var _a;
        const splitItems = (_a = txn.split) === null || _a === void 0 ? void 0 : _a.items;
        let items = [];
        if (Array.isArray(splitItems)) {
            items = splitItems;
        }
        else if (splitItems && typeof splitItems.toArray === 'function') {
            items = splitItems.toArray();
        }
        if (items.length === 0) {
            return (0, utils_3.toNumber)((0, utils_3.getTxnField)(txn, 'amount'));
        }
        if (splitItemId) {
            const matchedItem = items.find((split) => {
                const record = split;
                const id = typeof record.get === 'function' ? record.get('id') : split.id;
                const clientId = typeof record.get === 'function' ? record.get('clientId') : split.clientId;
                return (id && String(id) === String(splitItemId)) || (clientId && String(clientId) === String(splitItemId));
            });
            if (matchedItem) {
                const record = matchedItem;
                const amt = (0, utils_3.toNumber)(typeof record.get === 'function' ? record.get('amount') : matchedItem.amount);
                if (Number.isFinite(amt)) {
                    return amt;
                }
            }
        }
        let matched = false;
        let sum = 0;
        items.forEach((split) => {
            const splitRecord = split;
            const splitAmount = (0, utils_3.toNumber)(typeof splitRecord.get === 'function' ? splitRecord.get('amount') : split === null || split === void 0 ? void 0 : split.amount);
            if (!Number.isFinite(splitAmount)) {
                return;
            }
            const splitCoa = (typeof splitRecord.get === 'function' ? splitRecord.get('coa') : split === null || split === void 0 ? void 0 : split.coa);
            const splitForGrouping = typeof splitRecord.get === 'function'
                ? {
                    amount: splitAmount,
                    coa: splitCoa,
                    tags: splitRecord.get('tags'),
                }
                : split;
            if (row.categoryId) {
                const catIdStr = String(row.categoryId);
                const resolvedCatId = catIdStr.endsWith('__other')
                    ? catIdStr.slice(0, catIdStr.length - '__other'.length)
                    : row.categoryId;
                if ((splitCoa === null || splitCoa === void 0 ? void 0 : splitCoa.id) === resolvedCatId || String(splitCoa === null || splitCoa === void 0 ? void 0 : splitCoa.id) === String(resolvedCatId)) {
                    matched = true;
                    sum += splitAmount;
                    return;
                }
            }
            const { groupKeys } = (0, utils_1.getGroupingKeys)(txn, splitForGrouping, breakdownBy, categoriesById, tagsById);
            if (row.groupKey != null && (groupKeys === null || groupKeys === void 0 ? void 0 : groupKeys.includes(row.groupKey))) {
                matched = true;
                sum += splitAmount;
            }
        });
        return matched ? sum : (0, utils_3.toNumber)((0, utils_3.getTxnField)(txn, 'amount'));
    }, [breakdownBy, categoriesById, tagsById]);
    const getDisplayTxnsForRow = react_1.default.useCallback((txn, row, sectionKey) => {
        var _a, _b;
        const defaultRow = [{
                txn,
                displayTxn: txn,
                rowId: String((0, utils_3.getTxnField)(txn, 'id') || ''),
                amount: getTxnAmountForRow(txn, row),
            }];
        const splitItems = (_a = txn.split) === null || _a === void 0 ? void 0 : _a.items;
        let items = [];
        if (Array.isArray(splitItems)) {
            items = splitItems;
        }
        else if (splitItems && typeof splitItems.toArray === 'function') {
            items = splitItems.toArray();
        }
        if (items.length === 0) {
            return defaultRow;
        }
        const txnId = String((0, utils_3.getTxnField)(txn, 'id') || '');
        const rowSplitItemIds = ((_b = row === null || row === void 0 ? void 0 : row.splitItemIds) === null || _b === void 0 ? void 0 : _b[txnId]) || [];
        if (rowSplitItemIds.length > 0) {
            const matchingRows = rowSplitItemIds.flatMap((targetSplitItemId, index) => {
                const matchedItem = items.find((split) => {
                    const record = split;
                    const id = typeof record.get === 'function' ? record.get('id') : split.id;
                    const clientId = typeof record.get === 'function' ? record.get('clientId') : split.clientId;
                    return (id && String(id) === String(targetSplitItemId)) || (clientId && String(clientId) === String(targetSplitItemId));
                });
                if (!matchedItem) {
                    return [];
                }
                const record = matchedItem;
                const splitAmount = (0, utils_3.toNumber)(typeof record.get === 'function' ? record.get('amount') : matchedItem.amount);
                const displayTxn = txn.merge(matchedItem)
                    .set('split', undefined)
                    .set('amount', splitAmount);
                return [{
                        txn,
                        displayTxn,
                        rowId: `${txnId}:${String(targetSplitItemId || index)}`,
                        amount: splitAmount,
                    }];
            });
            if (matchingRows.length > 0) {
                return matchingRows;
            }
        }
        if (breakdownBy !== 'payee') {
            return defaultRow;
        }
        const matchingRows = items.flatMap((split, index) => {
            const splitRecord = split;
            const splitAmount = (0, utils_3.toNumber)(typeof splitRecord.get === 'function' ? splitRecord.get('amount') : split === null || split === void 0 ? void 0 : split.amount);
            const splitCoa = (typeof splitRecord.get === 'function' ? splitRecord.get('coa') : split === null || split === void 0 ? void 0 : split.coa);
            const splitCategory = (splitCoa === null || splitCoa === void 0 ? void 0 : splitCoa.type) === 'CATEGORY' && splitCoa.id
                ? categoriesById.get(String(splitCoa.id)) || categoriesById.get(splitCoa.id)
                : null;
            const matchesSection = sectionKey === 'income'
                ? (splitCategory === null || splitCategory === void 0 ? void 0 : splitCategory.type) === 'INCOME'
                : (splitCategory === null || splitCategory === void 0 ? void 0 : splitCategory.type) === 'EXPENSE';
            if (!matchesSection) {
                return [];
            }
            const displayTxn = txn.merge(split)
                .set('split', undefined)
                .set('amount', splitAmount);
            const splitId = typeof splitRecord.get === 'function' ? splitRecord.get('id') : split.id;
            return [{
                    txn,
                    displayTxn,
                    rowId: `${String((0, utils_3.getTxnField)(txn, 'id') || '')}:${String(splitId || index)}`,
                    amount: splitAmount,
                }];
        });
        return matchingRows.length > 0 ? matchingRows : defaultRow;
    }, [breakdownBy, categoriesById, getTxnAmountForRow]);
    const incomeReport = (0, react_redux_1.useSelector)((store) => reportsSelectors.getIncomeSpendingReportForDisplay(store, {
        reportName: 'itemized-income',
        dateRange: dateRange.value,
        timeStep,
        isOverTime: false,
        chartType: 'pie',
        groupBy: breakdownBy,
        filterObject,
    }));
    const expenseReport = (0, react_redux_1.useSelector)((store) => reportsSelectors.getIncomeSpendingReportForDisplay(store, {
        reportName: 'itemized-spending',
        dateRange: dateRange.value,
        timeStep,
        isOverTime: false,
        chartType: 'pie',
        groupBy: breakdownBy,
        filterObject,
    }));
    const incomeGroups = react_1.default.useMemo(() => {
        const raw = incomeReport === null || incomeReport === void 0 ? void 0 : incomeReport.get('rawReport');
        const groups = raw === null || raw === void 0 ? void 0 : raw.get('groups');
        return (0, utils_3.mapGroupRecordToNodes)(groups);
    }, [incomeReport]);
    const expenseGroups = react_1.default.useMemo(() => {
        const raw = expenseReport === null || expenseReport === void 0 ? void 0 : expenseReport.get('rawReport');
        const groups = raw === null || raw === void 0 ? void 0 : raw.get('groups');
        return (0, utils_3.mapGroupRecordToNodes)(groups);
    }, [expenseReport]);
    const maxDepth = 15;
    const incomeRows = react_1.default.useMemo(() => (0, utils_3.flattenNodesForView)((0, utils_3.injectOtherBucket)(incomeGroups), maxDepth), [incomeGroups, maxDepth]);
    const expenseRows = react_1.default.useMemo(() => (0, utils_3.flattenNodesForView)((0, utils_3.injectOtherBucket)(expenseGroups), maxDepth), [expenseGroups, maxDepth]);
    const handleHeaderSort = react_1.default.useCallback((nextSortBy) => {
        setHasUserSorted(true);
        if (nextSortBy === sortBy) {
            const nextDirection = sortDirection === 'asc' ? 'desc' : 'asc';
            setSortDirection(nextDirection);
            return;
        }
        const nextDirection = nextSortBy === 'date' || nextSortBy === 'amount' ? 'desc' : 'asc';
        setSortBy(nextSortBy);
        setSortDirection(nextDirection);
    }, [sortBy, sortDirection]);
    const allExpandableKeys = react_1.default.useMemo(() => {
        const collectKeys = (rows, sectionKey) => {
            const keys = [sectionKey];
            rows.forEach((row) => {
                const key = `${sectionKey}-${row.categoryId || row.groupKey}-${row.depth}`;
                const hasChildren = Array.isArray(row.subgroups) && row.subgroups.length > 0;
                const hasVisibleChildren = hasChildren && row.depth < maxDepth;
                const hasTxnRows = Boolean(row.txns && row.txns.size > 0);
                const canExpandLeafTxns = !hasVisibleChildren && hasTxnRows;
                if (hasVisibleChildren || canExpandLeafTxns) {
                    keys.push(key);
                }
            });
            return keys;
        };
        return collectKeys(incomeRows, 'income').concat(collectKeys(expenseRows, 'expenses'));
    }, [expenseRows, incomeRows, maxDepth]);
    const isAllPayeesExpanded = react_1.default.useMemo(() => {
        if (allExpandableKeys.length === 0) {
            return false;
        }
        return allExpandableKeys.every((k) => expandedKeys[k] === true);
    }, [allExpandableKeys, expandedKeys]);
    const setAllExpanded = react_1.default.useCallback((isExpanded) => {
        setExpandedKeys(allExpandableKeys.reduce((nextExpandedState, key) => (Object.assign(Object.assign({}, nextExpandedState), { [key]: isExpanded })), {}));
    }, [allExpandableKeys]);
    const visibleTxns = react_1.default.useMemo(() => {
        const collect = (rows) => {
            let result = (0, immutable_1.Set)();
            rows.forEach((row) => {
                const hasVisibleChildren = Array.isArray(row.subgroups) && row.subgroups.length > 0 && row.depth < maxDepth;
                if (!hasVisibleChildren && row.txns && row.txns.size > 0) {
                    result = result.union(row.txns);
                }
            });
            return result;
        };
        return collect(incomeRows).union(collect(expenseRows));
    }, [expenseRows, incomeRows, maxDepth]);
    const selectableVisibleTxns = react_1.default.useMemo(() => visibleTxns.filter((txn) => {
        var _a;
        const isTypeGrossPaycheck = transactions_1.transactionsUtils.isTxnGrossPaycheckType(txn, txnsByAccountId, scheduledTransactionsById);
        const isQueuePmt = utils_2.QUEUE_PAYMENTS.includes((_a = txn.check) === null || _a === void 0 ? void 0 : _a.number);
        return !isTypeGrossPaycheck && !isQueuePmt;
    }), [scheduledTransactionsById, txnsByAccountId, visibleTxns]);
    const toggleSelectAllVisible = react_1.default.useCallback(() => {
        if (selectableVisibleTxns.size === 0) {
            return;
        }
        setSelectedTxns((prev) => {
            const allSelected = selectableVisibleTxns.every((txn) => prev.has(txn));
            return allSelected ? prev.subtract(selectableVisibleTxns) : prev.union(selectableVisibleTxns);
        });
    }, [selectableVisibleTxns]);
    const toggleTxnSelected = react_1.default.useCallback((txn) => {
        var _a;
        const isTypeGrossPaycheck = transactions_1.transactionsUtils.isTxnGrossPaycheckType(txn, txnsByAccountId, scheduledTransactionsById);
        const isQueuePmt = utils_2.QUEUE_PAYMENTS.includes((_a = txn.check) === null || _a === void 0 ? void 0 : _a.number);
        if (isTypeGrossPaycheck || isQueuePmt) {
            return;
        }
        setSelectedTxns((prev) => (prev.has(txn) ? prev.remove(txn) : prev.add(txn)));
    }, [scheduledTransactionsById, txnsByAccountId]);
    const clearSelection = react_1.default.useCallback(() => setSelectedTxns((0, immutable_1.Set)()), []);
    const selectedTotal = react_1.default.useMemo(() => selectedTxns.toArray().reduce((total, txn) => total + (0, utils_3.toNumber)((0, utils_3.getTxnField)(txn, 'amount')), 0), [selectedTxns]);
    const setTxnReviewed = react_1.default.useCallback((txn) => {
        if (txn && !(0, utils_3.getTxnField)(txn, 'isReviewed')) {
            return txn.set('isReviewed', true);
        }
        return txn;
    }, []);
    const bulkEditSave = react_1.default.useCallback((fields) => {
        var _a;
        if (!fields || Object.keys(fields).length === 0) {
            return;
        }
        const { coa, tags: fieldTags } = fields, otherFields = __rest(fields, ["coa", "tags"]);
        const newTxns = (_a = selectedTxns.map((item) => {
            let newTxn = setTxnReviewed(item);
            if (!transactions_1.transactionsUtils.isSplitTxn(item)) {
                if (coa) {
                    newTxn = newTxn.set('coa', coa);
                }
                if (fieldTags) {
                    newTxn = newTxn.set('tags', newTxn.tags ? newTxn.tags.merge(fieldTags) : fieldTags);
                }
                if (item.source === types_1.TxnPendingStates.QCS_REFRESH_BANK_PENDING) {
                    newTxn = newTxn.set('source', types_1.TxnPendingStates.USER_OWNED_BANK_PENDING);
                }
            }
            return newTxn.merge(otherFields);
        })) !== null && _a !== void 0 ? _a : (0, immutable_1.Set)();
        const pluralSuffix = newTxns.size > 1 ? 's' : '';
        dialogAlert(`Save Changes To ${newTxns.size} Transaction${pluralSuffix}`, 'This will apply the specified changes to all eligible transactions you selected and cannot be undone. Do you want to proceed?', (button) => {
            if (button.btnPressed === 'Yes') {
                qDataSaveTransactions(newTxns);
                clearSelection();
            }
        }, ['Cancel', 'Yes'], 'warning', false);
    }, [selectedTxns, dialogAlert, qDataSaveTransactions, clearSelection, setTxnReviewed]);
    const bulkDelete = react_1.default.useCallback(() => {
        var _a;
        if (selectedTxns.size === 0) {
            return;
        }
        const deleteDownloaded = (_a = datasetPreferences === null || datasetPreferences === void 0 ? void 0 : datasetPreferences.transactionRegister) === null || _a === void 0 ? void 0 : _a.deleteDownloaded;
        if (!deleteDownloaded && selectedTxns.find((txn) => Boolean(txn.cpData))) {
            dialogAlert('You cannot delete downloaded transactions', 'You selected 1 or more transactions to delete which were downloaded by your financial institution.  It is not recommended that you delete data from your bank as it will not be downloaded again.', undefined, ['Cancel'], 'warning');
            return;
        }
        const numSelected = selectedTxns.size;
        dialogAlert(`Delete ${numSelected} Selected Transaction${numSelected > 1 ? 's' : ''}`, 'This action will delete all the selected transactions and cannot be undone.', (button) => {
            if (button.btnPressed === 'Delete') {
                qDataDeleteTransactions(selectedTxns.toArray(), { isBulkDelete: true });
                clearSelection();
            }
        }, ['Cancel', 'Delete'], 'delete', false);
    }, [selectedTxns, datasetPreferences, dialogAlert, qDataDeleteTransactions, clearSelection]);
    // ── Export logic ──
    const exportRows = react_1.default.useMemo(() => (0, utils_3.buildExportRows)({
        breakdownBy,
        incomeRows,
        expenseRows,
        incomeReport,
        expenseReport,
        isTransactionsView,
        maxDepth,
        sortBy,
        sortDirection,
        tagsById,
        getTxnAmountForRow,
        getAccountString: (id) => getAccountName(id),
        getCategoryName,
        formatAmount: utils_3.formatAmount,
    }), [
        breakdownBy,
        expenseReport,
        expenseRows,
        getAccountName,
        getCategoryName,
        getTxnAmountForRow,
        incomeReport,
        incomeRows,
        isTransactionsView,
        sortBy,
        sortDirection,
        tagsById,
    ]);
    const selectedExportRows = react_1.default.useMemo(() => (0, utils_3.buildSelectedExportRows)({
        breakdownBy,
        selectedTxns,
        sortBy,
        sortDirection,
        tagsById,
        getAccountString: (accountId) => getAccountName(accountId),
        getCategoryName,
        formatAmount: utils_3.formatAmount,
    }), [breakdownBy, selectedTxns, sortBy, sortDirection, tagsById, getAccountName, getCategoryName]);
    const datasetName = (dataset === null || dataset === void 0 ? void 0 : dataset.name) || 'Dataset';
    const exportSelectedCsv = react_1.default.useCallback(() => (0, utils_3.exportSelectedToCsv)(selectedExportRows, datasetName, breakdownBy), [selectedExportRows, datasetName, breakdownBy]);
    const handleDownloadFormat = react_1.default.useCallback((format) => {
        if (format === 'xlsx') {
            (0, utils_3.exportToXlsx)(exportRows, datasetName, breakdownBy);
        }
        else if (format === 'csv') {
            (0, utils_3.exportToCsv)(exportRows, datasetName, breakdownBy);
        }
        else if (format === 'pdf') {
            (0, utils_3.exportToPdf)(exportRows, datasetName, breakdownBy, dateRange.label, dateRange, filterObject, dataset);
        }
    }, [exportRows, datasetName, breakdownBy, dateRange, filterObject, dataset]);
    // ── Derived values ──
    const overallTotal = (0, utils_3.getGrandTotal)(incomeRows, expenseRows);
    return (<>
      {showBulkEdit && (<BulkEditPanel_1.default txnArray={selectedTxns} inDialog closeFn={() => setShowBulkEdit(false)} saveFn={bulkEditSave} longCats/>)}

      <Paper_1.default elevation={0} sx={{ backgroundColor: 'background.default' }}>
        <ChartSettings_1.default showDownloadButton handleDownload={handleDownloadFormat} resetTransactionRegister={() => {
            setExpandedKeys({});
        }} extraControls={isPayeeBreakdown ? (<div className={classes.expandAllGroup}>
              {isAllPayeesExpanded ? (<QButton_1.default startIcon={<Remove_1.default />} variant="outlinedBasic" onClick={() => setAllExpanded(false)} className={classes.expandAllButton} id="itemized_collapse_all">
                  Collapse All
                </QButton_1.default>) : (<QButton_1.default startIcon={<Add_1.default />} variant="outlinedBasic" onClick={() => setAllExpanded(true)} className={classes.expandAllButton} id="itemized_expand_all">
                  Expand All
                </QButton_1.default>)}
            </div>) : undefined} showViewFilter={!isPayeeBreakdown} viewOptions={types_2.viewOptions} viewValue={view} onViewChange={(option) => {
            const nextView = option.value;
            setView(nextView);
            setExpandedKeys({});
        }} breakdownOptions={types_2.breakdownOptions} breakdownValue={breakdownBy} onBreakdownChange={(option) => {
            setBreakdownBy(option.value);
            setExpandedKeys({});
        }}/>

        {incomeRows.length === 0 && expenseRows.length === 0 ? (<Box_1.default className={classes.tableZeroState} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <ZeroStateView_1.default primary=" " icon={happy_star_svg_1.default} secondary={<>
                  <span>None yet for {((_a = dateRange === null || dateRange === void 0 ? void 0 : dateRange.label) === null || _a === void 0 ? void 0 : _a.startsWith('Last')) ? 'the ' : ''}{(_b = dateRange === null || dateRange === void 0 ? void 0 : dateRange.label) === null || _b === void 0 ? void 0 : _b.toLowerCase()}</span>
                  <br />
                  <span>
                    {'Try '}
                    {hasFilters ? (<>
                        <span role="presentation" onClick={handleClearFilters} className={classes.clickableText}>
                          &nbsp;clearing filters&nbsp;
                        </span>
                        &quot;or choose &quot;
                      </>) : 'choosing '}
                    a different date range
                  </span>
                </>} secondaryTypographyProps={{ sx: { maxWidth: 'none', whiteSpace: 'nowrap' } }}/>
          </Box_1.default>) : (<ItemizedTable_1.default incomeRows={incomeRows} expenseRows={expenseRows} overallTotal={overallTotal} view={view} isTransactionsView={isTransactionsView} collapseAllByDefault={collapseAllByDefault} maxDepth={maxDepth} sortBy={sortBy} sortDirection={sortDirection} hasUserSorted={hasUserSorted} expandedKeys={expandedKeys} selectedTxns={selectedTxns} visibleTxns={selectableVisibleTxns} tagsById={tagsById} 
        // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
        checkboxSize={(_d = (_c = theme.mixins) === null || _c === void 0 ? void 0 : _c.register) === null || _d === void 0 ? void 0 : _d.checkboxSize} palette={palette} classes={classes} cx={cx} getAccountName={getAccountName} getTxnAmountForRow={getTxnAmountForRow} getDisplayTxnsForRow={getDisplayTxnsForRow} isPayeeBreakdown={isPayeeBreakdown} getCategoryName={getCategoryName} onHeaderSort={handleHeaderSort} onToggleExpanded={toggleExpanded} onToggleTxnSelected={toggleTxnSelected} onToggleSelectAllVisible={toggleSelectAllVisible} onShowBulkEdit={() => setShowBulkEdit(true)} onBulkDelete={bulkDelete} onExportSelectedCsv={exportSelectedCsv} selectedTotal={selectedTotal}/>)}
      </Paper_1.default>
    </>);
};
exports.default = ItemizedTransactions;
